export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    fixed: 'left',
    align: 'center',
    type: 'checkbox'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 140,
    slots: {
      default: 'opt'
    }
  },
  // {
  //   type: 'expand',
  //   width: 70,
  //   align: 'center',
  //   title: that.$l('INDEX.form_label_expand') || '展开',
  //   slots: {
  //     content: 'expandContent',
  //   },
  // },
  {
    title: that.$l('fabric_label_groupSpecName') || '规格名称',
    field: 'groupSpecName',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('fabric_label_fabricPositionName') || '面料位置',
    field: 'fabricPositionName',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_fabricNo') || '面料编号',
    field: 'fabricNo',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_fabricDisplayName') || '面料显示名称',
    field: 'fabricDisplayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_fabricWeight') || '面料克重',
    field: 'fabricWeight',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('form_label_isSpecify') || '客户指定供应商',
    field: 'isSpecify',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isSpecify'
    }
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmCode') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 280,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_isCustomerProvide') || '是否客供',
    field: 'isCustomerProvide',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isCustomerProvide'
    }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
    field: 'modifyByName',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
